module.exports = __webpack_public_path__ + "static/img/anxunModel31.9f7ffb48.png";